import { render, staticRenderFns } from "./WomensTotalRuleConfig.vue?vue&type=template&id=2dde72b5&scoped=true"
import script from "./WomensTotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./WomensTotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde72b5",
  null
  
)

export default component.exports